"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectPathToCssVarIdentifier = exports.objectPathToCssVarFunction = void 0;
var lodash_kebabcase_1 = __importDefault(require("lodash.kebabcase"));
/**
 * Given an object path (an array of strings) and a value, return a CSS var() function that represents it.
 *
 * Example:
 *  Input:
 *      path: [color, wisteria, 100]
 *      value: #f0f1f4
 *
 *  Output:
 *      "var(--color-wisteria-100, #f0f1f4)"
 *
 */
var objectPathToCssVarFunction = function (path, value) { return "var(".concat((0, exports.objectPathToCssVarIdentifier)(path), ", ").concat(value, ")"); };
exports.objectPathToCssVarFunction = objectPathToCssVarFunction;
/**
 * Given an object path (an array of strings), return a CSS variable identifier.
 *
 * Example:
 *      Input: [color, wisteria, 100]
 *
 *      Output: "--color-wisteria-100"
 */
var objectPathToCssVarIdentifier = function (path) {
    return "--".concat(path.map(lodash_kebabcase_1.default).join("-"));
};
exports.objectPathToCssVarIdentifier = objectPathToCssVarIdentifier;
//# sourceMappingURL=cssVariables.js.map